import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import NoImage from "assets/svgs/no_image";
import { Carousel, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PrescriptionScalpImage = (props) => {
  const [imageUrls, setImageUrl] = useState();
  const [selectedImage, setSelectedImage] = useState(null);

  const sortedImages = useMemo(() => {
    return props.images?.sort((a, b) => {
      return moment(b?.updated_at).diff(moment(a?.updated_at));
    });
  }, [props.images]);

  useEffect(() => {
    if (sortedImages) {
      const urls = sortedImages?.map((url) => {
        return {
          imageUrl: url.image,
          imageDate: moment(url?.updated_at).format("MMM DD YYYY"),
        };
      });
      setImageUrl(urls);
    }
  }, [sortedImages]);


  const handleImageClick = (image, index) => {
    const clickedImage = image[index];
    const updatedImageArray = [
      clickedImage,
      ...image.slice(0, index),
      ...image.slice(index + 1),
    ];
    setSelectedImage(updatedImageArray);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  return imageUrls?.length ? (
    <div
      style={{ height:"14rem", overflowY: "scroll", overflowX: "scroll" }}
      className="d-flex gap-2 p-2 scrollable-container"
    >
      {imageUrls?.map((image, index) => (
        <div className="d-flex flex-column bg-secondary shadow-lg rounded-2">
          <div className="d-flex flex-column w-100 cursor-pointer fw-bold table-row  rounded-2 p-2 align-items-center">
            <img
              key={index}
              height={122}
              src={image.imageUrl}
              width={112}
              onClick={() => handleImageClick(imageUrls, index)}
            />
            <span className="pt-2">{image.imageDate}</span>
          </div>
        </div>
      ))}
      <Modal show={selectedImage !== null} className="shadow-lg rounded" onHide={closeImageModal} size={"md"} style={{zIndex:"999999"}}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div style={{ width: "100%", height: "100%" }}>
            {selectedImage && (
              <Carousel
                className="theme-slider"
                nextIcon={<FontAwesomeIcon icon="angle-right" />}
                prevIcon={<FontAwesomeIcon icon="angle-left" />}
                style={{ backgroundColor: "grey" }}
              >
                {selectedImage?.map((item) => (
                  <Carousel.Item key={item}>
                    <img
                      className="d-block w-100"
                      src={item.imageUrl}
                      alt="Slide"
                      style={{
                        width: "35vh",
                        height: "60vh",
                        objectFit: "contain",
                      }}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  ) : (
    <div
      style={{ height: "14rem" }}
      className="d-flex flex-1 flex-column align-items-center py-2 m-1 justify-content-center"
    >
      <div>
        <NoImage />
      </div>
      <small>No image Available</small>
    </div>
  );
};

export default PrescriptionScalpImage;